import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CorreoPlantillaDto, ICategorizacionTramite, IConfiguracionLLaves, IControlTiempo, ITipoPlazo, TipoTramiteDto, VariablesRespuestaDinamicaParams } from '../../../../shared/interfaces/database/configuracion';
import { AccessRole, FormGroupErrorMessageComponent, FormNoData, LocalService, noWhitespaceValidator, Page, Utils } from 'lib-base';
import { VwSecDependencia } from '../../../../shared/interfaces/database/seguridad';
import { CategorizacionTramiteService } from '../../../../services/database/categorizacionTramite.service';
import { FormularioService } from '../../../../services/database/formulario.service';
import { TipoPlazoService } from '../../../../services/database/tipoPlazo.service';
import { SecDependenciaService } from '../../../../services/database/secDependencia.service';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { IGetCanalAtencion, IGetCaracteristicaEspecial, IGetDirigidoTramite, IGetEnfoqueDiferencial } from '../../../../shared/interfaces/database/evento';
import { CanalAtencionService } from '../../../../services/database/canalAtencion.service';
import { DirigidoTramiteService } from '../../../../services/database/dirigidoTramite.service';
import { EnfoqueDiferencialService } from '../../../../services/database/enfoqueDiferencial.service';
import { CaracteristicaEspecialService } from '../../../../services/database/caracteristicaEspecial.service';
import { firstValueFrom, forkJoin, Subscription } from 'rxjs';
import { IGetConceptosTramitesDisponibles } from '../../../../shared/interfaces/database/liquidacion';
import { ConceptosTramitesService } from '../../../../services/database/tipo-documento-recibo-pago.service';
import { InputMaskModule } from 'primeng/inputmask';
import { FileUpload, FileUploadHandlerEvent, FileUploadModule } from 'primeng/fileupload';
import { PanelModule } from 'primeng/panel';
import { CorreoTemplateService } from '../../../../services/database/correo-template.service';
import { ConfiguracionLlavesComponent, LlavesOptions } from '../../../../components/custom-work/other/configuracion-llaves/configuracion-llaves.component';
import { TipoTramiteActividaService } from '../../../../services/database/tipoTramiteActivida.service';
import { ControlTiempoService } from '../../../../services/database/control-tiempo.service';
import { ICustomComponent } from '../../../../../../../tramitantes/src/app/shared/interfaces/configuracion';
import { CustomComponentService } from '../../../../services/database/custom-component.service';

@Component({
  selector: 'app-wizard-tipo-tramite-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule,
    TranslateModule, InputTextareaModule, DropdownModule,
    InputTextModule, InputNumberModule, CheckboxModule,
    MultiSelectModule, TranslateModule, FormGroupErrorMessageComponent,
    TooltipModule, ButtonModule, InputMaskModule,
    FileUploadModule, PanelModule, ConfiguracionLlavesComponent
  ],
  templateUrl: './wizard-tipo-tramite-form.component.html'
})
export class WizardTipoTramiteFormComponent implements OnInit, OnDestroy {
  @Input() tipoTramiteId?: number;

  tipoTramite !: TipoTramiteDto;
  tipoTramiteForm !: FormGroup;
  categorizaciones !: ICategorizacionTramite[];

  formularios !: FormNoData[];
  dependencias !: VwSecDependencia[];
  role = AccessRole;
  trans: any = {};
  requierePagoOptions = [{ id: true, nombre: 'Si' }, { id: false, nombre: 'No' }];
  canalesAtencion !: IGetCanalAtencion[];
  dirigidoTramite !: IGetDirigidoTramite[];
  enfoqueDiferencial !: IGetEnfoqueDiferencial[];
  caracteristicasEspeciales !: IGetCaracteristicaEspecial[];
  conceptosTramites !: IGetConceptosTramitesDisponibles[];
  private readonly _requierePagoSubscription !: Subscription | undefined;
  
  formulariosReady: boolean = false;
  formularioVersionNotLatest: boolean = false;

  //Documento de firma
  readonly uploadFileSize: number = 1024 * 1024
  invalidSize = false;
  firmaDeComprobante?: File = undefined;

  //Respuesta Dinamica
  variablesRespDinamica!: IConfiguracionLLaves[];
  correosTemplate!: CorreoPlantillaDto[];
  correosTemplateReady: boolean = true;
  correoPlantillaVersionNotLatest: boolean = false;

  //Control de tiempo
  controlTiempos !: IControlTiempo[];
  controlTiemposReady: boolean = false;
  controlTiempoVersionNotLatest: boolean = false;

  @ViewChild(ConfiguracionLlavesComponent) configuracionLlavesComponent !: ConfiguracionLlavesComponent;

  //Componentes Personalizados
  componentsPersonalizados !: ICustomComponent[];

  constructor(private readonly _fb: FormBuilder, private readonly _router: Router,
    private readonly _ct: CategorizacionTramiteService, private readonly _fo: FormularioService,
    private readonly _tp: TipoPlazoService, private readonly _sd: SecDependenciaService,
    private readonly _cts: ConceptosTramitesService, public ls: LocalService,
    private readonly _ca: CanalAtencionService, private readonly _dt: DirigidoTramiteService,
    private readonly _ed: EnfoqueDiferencialService, private readonly _ce: CaracteristicaEspecialService,
    private readonly _cots: CorreoTemplateService, private readonly _tas: TipoTramiteActividaService,
    private readonly _t: TranslateService, private readonly _ctis: ControlTiempoService, private readonly _ccs: CustomComponentService
  ) {
    this.configureTipoTramiteForm();

    this._requierePagoSubscription = this.tipoTramiteForm.get('requierePago')?.valueChanges.subscribe((value) => {
      if (!value) {
        this.tipoTramiteForm.get('tipoCuenta')?.setValue(' ');
        this.tipoTramiteForm.get('nombreBanco')?.setValue(' ');
        this.tipoTramiteForm.get('numeroCuenta')?.setValue(' ');
      }
    });
  }

  ngOnDestroy(): void {
    if (this._requierePagoSubscription) {
      this._requierePagoSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.translate();
    this.setupNewForm();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      variablesCorreo: this._t.get('common.variablesCorreo'),
      variablesTramite: this._t.get('common.variablesTramite'),
      noHayValoresValidosConfiguracionLlaves: this._t.get('msg.noHayValoresValidosConfiguracionLlaves')

    }));
  }

  //#region Form Configuration
  set formCorreoPlantillaId(value: number) {
    this.tipoTramiteForm.patchValue({ correoPlantillaId: value });
  }

  get formCorreoPlantillaId() {
    return this.tipoTramiteForm.get('correoPlantillaId')?.value;
  }

  get isPristine() {
    return this.tipoTramiteForm.pristine;
  }

  get requierePago() {
    return this.tipoTramiteForm.get('requierePago')?.value ?? false
  }

  get formComponentPersonalizado() {
    return this.tipoTramiteForm.get('componentPersonalizado')?.value;
  }

  set formComponentPersonalizado(value: ICustomComponent) {
    this.tipoTramiteForm.patchValue({ componentPersonalizado: value });
  }

  get formFormulario(): number | undefined {   
    return this.tipoTramiteForm.get('formularioId')?.value;
  }

  get formControlDeTiempo(): number | undefined {
    return this.tipoTramiteForm.get('controlDeTiempoId')?.value;
  }

  configureTipoTramiteForm() {
    this.tipoTramiteForm = this._fb.group({
      categorizacionId: [null, [Validators.required]],
      formularioId: [null, [Validators.required]],
      controlDeTiempoId: [null, [Validators.required]],
      descripcion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
      descripcionBreve: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(1000)]],
      dependenciaId: [null, [Validators.required]],
      requierePago: [false, [Validators.required]],
      asignacionManual: [false],
      //hoja de vida
      canalAtencionIds: [null, [Validators.required]],
      enfoqueDiferencialIds: [null, [Validators.required]],
      caracteristicaEspecialIds: [null, [Validators.required]],
      dirigidoTramiteIds: [null, [Validators.required]],
      periodo: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
      horariosAtencion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
      requisitos: [null, [Validators.required, noWhitespaceValidator]],
      ruta: [null, [Validators.required, noWhitespaceValidator]],
      relacion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
      norma: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
      //requiere pago==
      tipoCuenta: [null, [Validators.required, Validators.maxLength(255)]],
      nombreBanco: [null, [Validators.required, Validators.maxLength(255)]],
      numeroCuenta: [null, [Validators.required, Validators.maxLength(255)]],
      conceptosTramitesId: [null],
      iac: [null],
      //===
      direccion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
      telefono: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
      correo: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
      observaciones: [null, [Validators.maxLength(255)]],
      tieneFirmaComprobante: [false],
      urlTramite: [null],
      nombreFirmante: [null],
      //Correo plantilla
      correoPlantillaId: [null],
      //Componentes personalizados
      componentPersonalizado: [null]
    });
    this.subscriptionsTipoTramiteForm();
  }

  private subscriptionsTipoTramiteForm() {
    this.tipoTramiteForm.get("correoPlantillaId")?.valueChanges.subscribe((value) => {
      this.correoPlantillaIdOnValueChanges(value);
    });
    this.tipoTramiteForm.get("formularioId")?.valueChanges.subscribe((formularioKey) => {
      if (!formularioKey) {
        return;
      }
      this.getVariablesRespuestaDinamica(formularioKey);
    });
  }

  private setupNewForm() {
    this.tipoTramiteForm.reset();
    this.getCategorizaciones();
    this.getFormularios();
    this.getControlDeTiempo();
    this.getDependencias();
    this.getConceptosTramitesDisponibles();
    this.getCanalesAtencion();
    this.getDirigidoTramite();
    this.getEnfoqueDiferencial();
    this.getCaracteristicaEspecial();
    this.getCorreoPlantillaDetail();
    this.getComponentsPersonalizados();
  }

  resetForm() {
    this.tipoTramiteForm.reset();
  }

  isFormCompleted(): boolean {

    if (this.tipoTramiteForm.invalid) {
      Utils.markAllFormControlsAsTouched(this.tipoTramiteForm);
      return false;
    }

    if(this.formCorreoPlantillaId){
      if(!this.configuracionLlavesComponent.isValid()){
        return false;
      }
    }

    const requierePago = this.tipoTramiteForm.get('requierePago')?.value;
    const iac = this.tipoTramiteForm.get('iac');
    const conceptosTramitesId = this.tipoTramiteForm.get('conceptosTramitesId');

    if (requierePago) {
      if ((!iac?.value && !conceptosTramitesId?.value)) {
        return false;
      }
      if (conceptosTramitesId?.value) {
        iac?.setValue(null);
      }
      if (iac?.value) {
        conceptosTramitesId?.setValue(null);
      }
    }

    return true;
  }

  getForm(): TipoTramiteDto {
    const requierePago = this.tipoTramiteForm.get('requierePago')?.value;
    const componentsPersonalizados = this.formComponentPersonalizado;   
    const formulario = this.formularios.find(f => f.id === this.formFormulario);
    const correoPlantilla = this.correosTemplate.find(c => c.id === this.formCorreoPlantillaId);
    const tipoTramite = {
      categorizacionId: this.tipoTramiteForm.get('categorizacionId')?.value,
      formularioId: formulario ? formulario.id : undefined,
      formularioVersion: formulario ? formulario.version : undefined,
      //control de tiempo
      controlDeTiempoId: this.formControlDeTiempo,

      descripcion: this.tipoTramiteForm.get('descripcion')?.value,
      descripcionBreve: this.tipoTramiteForm.get('descripcionBreve')?.value,
      produccion: false,
      dependenciaId: this.tipoTramiteForm.get('dependenciaId')?.value,
      asignacionManual: this.tipoTramiteForm.get('asignacionManual')?.value,
      canalAtencionIds: this.tipoTramiteForm.get('canalAtencionIds')?.value,
      enfoqueDiferencialIds: this.tipoTramiteForm.get('enfoqueDiferencialIds')?.value,
      caracteristicaEspecialIds: this.tipoTramiteForm.get('caracteristicaEspecialIds')?.value,
      dirigidoTramiteIds: this.tipoTramiteForm.get('dirigidoTramiteIds')?.value,
      periodo: this.tipoTramiteForm.get('periodo')?.value,
      horariosAtencion: this.tipoTramiteForm.get('horariosAtencion')?.value,
      requisitos: this.tipoTramiteForm.get('requisitos')?.value,
      ruta: this.tipoTramiteForm.get('ruta')?.value,
      relacion: this.tipoTramiteForm.get('relacion')?.value,
      norma: this.tipoTramiteForm.get('norma')?.value,

      requierePago: requierePago,
      tipoCuenta: requierePago ? this.tipoTramiteForm.get('tipoCuenta')?.value : ' ',
      nombreBanco: requierePago ? this.tipoTramiteForm.get('nombreBanco')?.value : ' ',
      numeroCuenta: requierePago ? this.tipoTramiteForm.get('numeroCuenta')?.value : ' ',
      conceptosTramitesId: this.tipoTramiteForm.get('conceptosTramitesId')?.value,
      iac: this.tipoTramiteForm.get('iac')?.value,

      direccion: this.tipoTramiteForm.get('direccion')?.value,
      telefono: this.tipoTramiteForm.get('telefono')?.value,
      correo: this.tipoTramiteForm.get('correo')?.value,
      observaciones: this.tipoTramiteForm.get('observaciones')?.value,
      urlTramite: this.tipoTramiteForm.get('urlTramite')?.value,
      tieneFirmaComprobante: this.tipoTramiteForm.get('tieneFirmaComprobante')?.value || false,
      nombreFirmante: this.tipoTramiteForm.get('nombreFirmante')?.value,
      //respuesta dinamica
      respuestaDinamicaPlantillaId: correoPlantilla ? correoPlantilla.id : undefined,
      respuestaDinamicaPlantillaVersion: correoPlantilla ? correoPlantilla.version : undefined,
      respuestaDinamicaConfiguracionLlaves: this.configuracionLlavesComponent.getValues(),
      //componente personalizado
      customComponentId: componentsPersonalizados? componentsPersonalizados.id : undefined,
      customComponentVersion: componentsPersonalizados? componentsPersonalizados.version : undefined
    } as TipoTramiteDto
    return tipoTramite;
  }

  loadForm(data: TipoTramiteDto) {
    this.tipoTramite = data;
    this.tipoTramiteForm.get('categorizacionId')?.setValue(data.categorizacionId);
    this.tipoTramiteForm.get('formularioId')?.setValue(data.formularioId);
    this.tipoTramiteForm.get('controlDeTiempoId')?.setValue(data.controlDeTiempoId);
    this.tipoTramiteForm.get('descripcion')?.setValue(data.descripcion);
    this.tipoTramiteForm.get('descripcionBreve')?.setValue(data.descripcionBreve);
    this.tipoTramiteForm.get('dependenciaId')?.setValue(data.dependenciaId);
    this.tipoTramiteForm.get('requierePago')?.setValue(data.requierePago);
    this.tipoTramiteForm.get('asignacionManual')?.setValue(data.asignacionManual);
    this.tipoTramiteForm.get('canalAtencionIds')?.setValue(data.canalAtencionIds);
    this.tipoTramiteForm.get('enfoqueDiferencialIds')?.setValue(data.enfoqueDiferencialIds);
    this.tipoTramiteForm.get('caracteristicaEspecialIds')?.setValue(data.caracteristicaEspecialIds);
    this.tipoTramiteForm.get('dirigidoTramiteIds')?.setValue(data.dirigidoTramiteIds);
    this.tipoTramiteForm.get('periodo')?.setValue(data.periodo);
    this.tipoTramiteForm.get('horariosAtencion')?.setValue(data.horariosAtencion);
    this.tipoTramiteForm.get('requisitos')?.setValue(data.requisitos);
    this.tipoTramiteForm.get('ruta')?.setValue(data.ruta);
    this.tipoTramiteForm.get('relacion')?.setValue(data.relacion);
    this.tipoTramiteForm.get('norma')?.setValue(data.norma);
    this.tipoTramiteForm.get('requierePago')?.setValue(data.requierePago);
    this.tipoTramiteForm.get('tipoCuenta')?.setValue(data.tipoCuenta);
    this.tipoTramiteForm.get('nombreBanco')?.setValue(data.nombreBanco);
    this.tipoTramiteForm.get('numeroCuenta')?.setValue(data.numeroCuenta);
    this.tipoTramiteForm.get('conceptosTramitesId')?.setValue(data.conceptosTramitesId);
    this.tipoTramiteForm.get('iac')?.setValue(data.iac);
    this.tipoTramiteForm.get('direccion')?.setValue(data.direccion);
    this.tipoTramiteForm.get('telefono')?.setValue(data.telefono);
    this.tipoTramiteForm.get('correo')?.setValue(data.correo);
    this.tipoTramiteForm.get('observaciones')?.setValue(data.observaciones);
    this.tipoTramiteForm.get('urlTramite')?.setValue(data.urlTramite);
    this.tipoTramiteForm.get('tieneFirmaComprobante')?.setValue(data.tieneFirmaComprobante);
    this.tipoTramiteForm.get('nombreFirmante')?.setValue(data.nombreFirmante);
    this.getConceptosTramitesDisponibles();
    this.tryToSetComponentPersonalizado();
    this.tryToConfigureFormularioData();
    this.tryToConfigureCorreosTemplate();
    this.tryToConfigureControlDeTiempo();
  }

  /** 
   * Intenta cargar los datos que dependen de que otros componentes hayan cargado su información previamente
  */
  private tryToConfigureFormularioData(){
    const formFormularioKey = this.formFormulario;
    if(!this.formulariosReady || !formFormularioKey)
      return;
    const formulario = this.formularios.find(f => f.id === formFormularioKey);
    if (formulario?.version !== this.tipoTramite.formularioVersion)
      this.formularioVersionNotLatest = true
  }

  //#endregion formulario

  openLink(index: number) {
    switch (index) {
      case 0:
        window.open(`/#/configuracion/admin-tramites?tabIndex=1`, '_blank');
        break;
      case 1:
        window.open('/#/seguridad/admin-dependencias', '_blank');
        break;
      case 2:
        window.open('/#/configuracion/admin-tramites?tabIndex=1', '_blank');
        break;
      case 3:
        window.open('/#/configuracion/formulario/edit', '_blank');
        break;
      case 4:
        this._router.navigate(['/configuracion/admin-tramites'], { queryParams: { tabIndex: 0 } });
        break;
    }

  }

  //#region firma archivo

  removerFirmaArchivo() {
    this.firmaDeComprobante = undefined;
    this.invalidSize = false;
    this.tipoTramiteForm.get('tieneFirmaComprobante')?.setValue(false);
  }

  uploadFirmaHandler(event: FileUploadHandlerEvent, fileUpload: FileUpload) {
    const file = event.files[0];
    this.invalidSize = false;
    //validate file size
    if (file.size > this.uploadFileSize) {
      this.invalidSize = true;
      fileUpload.clear();
      return;
    }
    this.firmaDeComprobante = file;
    fileUpload.clear();
    this.tipoTramiteForm.get('tieneFirmaComprobante')?.setValue(true);
  }
  //#endregion firma archivo

  //#region Respuesta Dinamica
  private getCorreoPlantillaDetail() {
    this._cots.getCorreoPlantillaDetail().subscribe({
      next: data => {
        this.correosTemplate = data;
        this.correosTemplateReady = true;
        this.tryToConfigureCorreosTemplate();
      }
    });
  }

  private tryToConfigureCorreosTemplate() {
    if(!this.correosTemplateReady || !this.formCorreoPlantillaId)
      return;
    const correoPlantilla = this.correosTemplate.find(c => c.id === this.formCorreoPlantillaId);
    if(correoPlantilla?.version !== this.tipoTramite.respuestaDinamicaPlantillaVersion)
      this.correoPlantillaVersionNotLatest = true;

    this.intializeConfiguracionLlaves(this.formCorreoPlantillaId);
  }

  private getVariablesRespuestaDinamica(formularioId: number) {
    const formulario: FormNoData | undefined = this.formularios.find(f => f.id === formularioId);
    if (!formulario) {
      return;
    }

    this._tas.getVariablesRespuestaDinamica({ formularioId: formulario.id, formularioVersion: formulario.version } as VariablesRespuestaDinamicaParams).subscribe({
      next: (data: IConfiguracionLLaves[]) => {
        this.variablesRespDinamica = data
        this.formCorreoPlantillaId = this.tipoTramite.respuestaDinamicaPlantillaId;
        this.tryToConfigureCorreosTemplate();
        setTimeout(() => {
          this.configuracionLlavesComponent.load(this.tipoTramite?.respuestaDinamicaConfiguracionLlaves ?? []);
        }, 1);
      }
    });
  }

  oncorreoPlantillaIdClear($event: Event) {
    this.configuracionLlavesComponent.reset();
  }

  private intializeConfiguracionLlaves(value: number) {
    if (!this.configuracionLlavesComponent) {
      return;
    }
    this.configuracionLlavesComponent.reset();
    const selectedTemplate = this.correosTemplate.find(t => t.id === value);
    if (selectedTemplate) {
      const keysData = selectedTemplate.variables?.map(v => ({ name: v, value: v })) || [];
      let keys = {
        data: keysData,
        optionLabel: 'name',
        optionValue: 'value',
        headerText: this.trans.variablesCorreo
      } as LlavesOptions
      let values = {
        data: this.variablesRespDinamica,
        optionLabel: 'name',
        optionValue: 'name',
        headerText: this.trans.variablesTramite
      } as LlavesOptions
      this.configuracionLlavesComponent.loadOptions(keys, values);

      for (const key of keysData) {
        const newItem = this.configuracionLlavesComponent.addNew();
        newItem.name = key.value;
      }
    }
  }

  correoPlantillaIdOnValueChanges(value: number) {
    if (!value) {
      return;
    }
    this.intializeConfiguracionLlaves(value);
  }

  //#endregion Respuesta Dinamica
  
  //#region control de tiempo

  getControlDeTiempo() {
    if (this.controlTiempos) return;
    this._ctis.getList().subscribe({
      next: (controlTiempos: IControlTiempo[]) => {
        this.controlTiempos = controlTiempos;
        this.controlTiemposReady = true;
        this.tryToConfigureControlDeTiempo();
      }
    });
  }

  tryToConfigureControlDeTiempo() {
    if(!this.controlTiemposReady || !this.formControlDeTiempo)
      return;
    const controlTiempo = this.controlTiempos.find(c => c.id === this.formControlDeTiempo);
    if(controlTiempo?.version !== this.tipoTramite.controlDeTiempoVersion)
      this.controlTiempoVersionNotLatest = true;
  }

  //#endregion control de tiempo

  //#region API
  getCategorizaciones() {
    this._ct.getCategorizaciones().subscribe({
      next: (categorizaciones: ICategorizacionTramite[]) => {
        this.categorizaciones = categorizaciones;
      }
    });
  }

  getFormularios() {
    this._fo.getFormsNoData().subscribe({
      next: (forms: FormNoData[]) => {
        this.formularios = forms;
        this.formulariosReady = true;
        this.tryToConfigureFormularioData();
      }
    });
  }

  getDependencias() {
    this._sd.getDependencias().subscribe({
      next: (page: Page<VwSecDependencia>) => {
        this.dependencias = page.content;
      }
    });
  }

  getConceptosTramitesDisponibles() {
    this._cts.getConceptosTramitesDisponibles(this.tipoTramiteId).subscribe({
      next: (data: IGetConceptosTramitesDisponibles[]) => {
        this.conceptosTramites = data;
      }
    });
  }

  getCanalesAtencion() {
    this._ca.getCanalesAtencions().subscribe({
      next: (response: IGetCanalAtencion[]) => {
        this.canalesAtencion = response
      }
    });
  }

  getDirigidoTramite() {
    this._dt.getDirigidoTramite().subscribe({
      next: (response: IGetDirigidoTramite[]) => {
        this.dirigidoTramite = response;
      }
    });
  }

  getEnfoqueDiferencial() {
    this._ed.getEnfoqueDiferencial().subscribe({
      next: (response: IGetEnfoqueDiferencial[]) => {
        this.enfoqueDiferencial = response;
      }
    });
  }

  getCaracteristicaEspecial() {
    this._ce.getCaracteristicaEspecial().subscribe({
      next: (response: IGetCaracteristicaEspecial[]) => {
        this.caracteristicasEspeciales = response;
      }
    });
  }
  //#endregion API

  //#region Componentes Personalizados
  getComponentsPersonalizados(): void {
    this._ccs.getAll().subscribe({
      next: (data: ICustomComponent[]) => {
        this.componentsPersonalizados = data;
        this.tryToSetComponentPersonalizado();
      }
    });
  }

  tryToSetComponentPersonalizado(): void {
    if (!this.tipoTramite || !this.componentsPersonalizados) return;
    const componente = this.componentsPersonalizados.find(c => c.id === this.tipoTramite.customComponentId && c.version === this.tipoTramite.customComponentVersion);
    if (componente) {
      this.formComponentPersonalizado = componente;
    }
  }

  //#endregion Componentes Personalizados
}
